<template>
  <span>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          {{ item[slotData.name] }}
        </span>
      </template>
      <p class="pa-2 ma-0">
        {{ $t("projects.current-costs") }}:
        {{ data.project && data.project.gross }} {{ data.currency }}/{{
          $t("projects.year")
        }}
        <br />
        {{
          $t(
            `projects.cost-difference-${isActive ? "deactivate" : "activate"}`
          )
        }}: {{ getDifference }} {{ data.currency }}/{{ $t("projects.year") }}
        <br />
        {{
          $t(
            `projects.costs-after-${isActive ? "deactivation" : "activation"}`
          )
        }}: {{ data.custom && data.custom.gross }} {{ data.currency }}/{{
          $t("projects.year")
        }}
        <br />
        {{ $t("projects.vat-rate") }} ({{ data.vat_rate }}%)
      </p>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: "DateItem",
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      data: {}
    };
  },
  computed: {
    isActive() {
      return this.item.isActive;
    },
    getDifference() {
      let dif = this.data.difference && this.data.difference.gross;
      if (!dif || !dif[0]) {
        return "0";
      }
      if (dif[0] === "0" && dif.length === 1) {
        return dif;
      }
      if (dif[0] === "-") {
        return dif.replace("-", "- ");
      }
      return `+ ${dif}`;
    }
  },
  methods: {
    updateCosts() {
      let isActive = this.isActive;
      let listIds = this.list
        .filter(i => (i.id === this.item.id ? !isActive : i.isActive))
        .map(i => i.id);
      this.$store
        .dispatch("pricingStore/getCosts", {
          params: {
            withModules: listIds.join(","),
            project: this.$route.params.id
          }
        })
        .then(data => {
          this.data = data.data;
        });
    }
  },

  watch: {
    "item.isActive": function() {
      this.updateCosts();
    }
  },
  mounted() {
    this.updateCosts();
  }
};
</script>

<style scoped></style>
